import { Badge } from "@chakra-ui/react";

export function TasksNewStatusBadge({
  status,
}: {
  status: "COMPLETED" | "INCOMPLETED" | "APPROVED" | null;
}) {
  switch (status) {
    case "APPROVED":
      return <Badge colorScheme="blue">Approved</Badge>;
    case "COMPLETED":
      return <Badge colorScheme="green">Completed</Badge>;
    case "INCOMPLETED":
      return <Badge colorScheme="gray">Incompleted</Badge>;
    case null:
      return <Badge colorScheme="gray">Incompleted</Badge>;
  }
}
